<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>基本情報</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <form [formGroup]="tankatableBasicInfoForm">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%] tw-md:max-w-[full]">
                    <mat-label>単価表名</mat-label>
                    <input matInput readonly="true" formControlName="tankatableAname" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%] tw-md:max-w-[full]">
                    <mat-label>単価表説明</mat-label>
                    <input matInput readonly="true" formControlName="tankatableExplanation" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%] tw-md:max-w-[full]">
                    <mat-label>単価表コード</mat-label>
                    <input matInput readonly="true" formControlName="tankatableCode" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-md:max-w-[full]">
                    <mat-label>会社</mat-label>
                    <input matInput readonly="true" formControlName="companyname" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-md:max-w-[full]">
                    <mat-label>エネルギー種別</mat-label>
                    <input matInput readonly="true" formControlName="energyClsname" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-md:max-w-[full]">
                    <mat-label>ＬＰ販売形態</mat-label>
                    <input matInput readonly="true" formControlName="lpSalfrmAname" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-md:max-w-[full]">
                    <mat-label>地点群／供給地点区分</mat-label>
                    <input matInput readonly="true" formControlName="locationgroupSuppntDivisionname" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%] tw-md:max-w-[full]">
                    <mat-label>料金プラン</mat-label>
                    <input matInput readonly="true" formControlName="prdAname" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-md:max-w-[full]">
                    <mat-label>スライド調整単価名</mat-label>
                    <input matInput readonly="true" formControlName="slideadjustmentunitpriceAname" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
            </div>
            <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center"
                style="white-space: pre-wrap">
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[90%] tw-lg:max-w-[full]">
                    <mat-label>単価表メモ</mat-label>
                    <textarea matInput id="memo" readonly="true" formControlName="tankatableMemo"
                        class="font-color-display-only" disabled>
            </textarea>
                </mat-form-field>
            </div>
        </form>
    </mat-card-content>
</mat-card>